import { Route, Switch, useRouteMatch } from "react-router-dom";

import GoalPageHeader from "@apps/goal-overview/header";
import useDocumentTitle from "@components/use-document-title/use-document-title";

import KPIEdit from "./components/edit";
import KPIGroupForm from "./components/group-form";
import KPIList from "./components/list";
import KPIView from "./components/view";

const KPIs = () => {
  useDocumentTitle("KPIs");
  const { path } = useRouteMatch();

  return (
    <div aria-label="Goals" className="flex flex-col flex-1 w-full">
      <GoalPageHeader />
      <div aria-label="KPIs" className="flex flex-col flex-1">
        <div className="p-6">
          <Switch>
            <Route exact path={[`${path}`]}>
              <KPIList />
            </Route>
            <Route
              exact
              path={[`${path}/group/new`, `${path}/group/:kpiGroupId(\\d+)`]}
            >
              <KPIGroupForm />
            </Route>
            <Route exact path={[`${path}/new`, `${path}/:kpiId(\\d+)/edit`]}>
              <KPIEdit />
            </Route>
            <Route path={`${path}/:kpiId(\\d+)`}>
              <KPIView />
            </Route>
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default KPIs;
